import React from 'react'

export default function ReturnsStepHeader({headerLabel, isFirstStep, isStoreComponents, isLockersComponents,}) {
  return (
    <>
      { !isStoreComponents && !isLockersComponents && (
        <div className="retailer__new-label-tabbed-header">

          <h3>{headerLabel}</h3>

          <ul className="retailer__new-label-step-numbers">
              <li className={`retailer__new-label-step-number${isFirstStep ? " selected" : ""}`}>Step 1</li>

              <li className={`retailer__new-label-step-number${!isFirstStep ? " selected" : ""}`}>Step 2</li>
          </ul>
        </div>
      )}

      { (isStoreComponents || isLockersComponents) && (
        <h3>{headerLabel}</h3>
      )}
    </>
  )
}
